module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/error_404-5e2fc9f7483d1b782aa2d0148e7d86e3.png";